import anime from "animejs";

import {raf} from "./util";

export function registerArrangementenFilter() {
    raf(() => {
        if (!document.body.classList.contains("filter-arrangementen"))
            return;

        new ArrangementFilter();
    });
}

function animeWithCallback(options, fn) {
    const animation = anime(options);

    animation.complete = fn;

    return animation;
}

function hasAnyOf(own, list) {
    for (let item of list)
        if (own.indexOf(item) === -1)
            return false;

    return true;
}

class ArrangementFilter {
    constructor() {
        this.campings = Array.prototype.slice.call(document.querySelectorAll(".arrangement-item"));
        this.filter = {
            overview: document.querySelector("div.arrangement-overview"),
            properties: document.querySelectorAll("input[type=checkbox].filter-setting-arrangement"),
        };
        this.state = {
            place: null,
            radius: 100,
            firstTime: true
        };

        window.addEventListener("load", () => this.updateFilter());

        Array.prototype.slice.call(this.filter.properties).forEach(prop => prop.addEventListener("change", () => this.updateFilter()));
    }

    updateFilter() {
        animeWithCallback({targets: this.filter.overview, opacity: 0, duration: this.state.firstTime ? 0 : 300, easing: 'cubicBezier(.55, 0, .1, 1)'}, () => {
            this.state.firstTime = false;

            let checkedFilterProperties = Array.prototype.slice.call(this.filter.properties).filter(p => p.checked);
            let valuesFilterProperties = checkedFilterProperties.map(p => p.value);

            for (let camping of this.campings) {
                const box = camping.parentNode;
                const properties = (camping.dataset.properties || "").split(";");
                let show = true;

                box.style.setProperty("display", "none");

                if (valuesFilterProperties.length > 0 && !hasAnyOf(properties, valuesFilterProperties))
                    show = false;

                if (show)
                    box.style.setProperty("display", "inline-block");
            }

            window.dispatchEvent(new CustomEvent("hcdc:lazy-maybe-visible"));

            anime({
                targets: this.filter.overview,
                duration: 300,
                easing: 'cubicBezier(.55, 0, .1, 1)',
                opacity: 1
            })
        });
    }
}
